"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fork = fork;
exports.default = curriedFork;

var _iterable = require("../../internal/iterable");

var _exchange = require("./internal/exchange");

function fetch(state) {
  const {
    exchange,
    iterator
  } = state;
  {
    const newItem = iterator.next();

    if (newItem.done) {
      state.done = true;
      state.doneValue = newItem.value;
    } else {
      exchange.push(newItem.value);
    }
  }
}

function returnIterator(state) {
  const {
    exchange,
    iterableCounter,
    iterator
  } = state;

  if (!exchange.hasRoot() && iterableCounter === 0) {
    if (typeof iterator.return === 'function') iterator.return();
  }
}

function* generateFork(state, consumer) {
  try {
    state.iterableCounter++;
    yield 'ensure finally';

    while (true) {
      if (!consumer.isEmpty()) {
        yield consumer.shift();
      } else if (state.done) {
        return state.doneValue;
      } else {
        fetch(state);
      }
    }
  } finally {
    state.iterableCounter--;
    returnIterator(state);
  }
}

function* generateForks(state, n) {
  const {
    exchange
  } = state;

  try {
    for (let counter = 0; counter < n; counter++) {
      const fork = generateFork(state, exchange.spawnConsumerAtRoot());
      fork.next();
      yield fork;
    }
  } finally {
    exchange.discardRoot();
    returnIterator(state);
  }
}

function fork(source, n = Infinity) {
  const state = {
    iterator: (0, _iterable.ensureIterable)(source)[Symbol.iterator](),
    iterableCounter: 0,
    exchange: new _exchange.Exchange(),
    done: false,
    doneValue: undefined
  };
  return generateForks(state, n);
}

function curriedFork(...args) {
  if (args.length >= 2) {
    const [n, iterable] = args;
    return fork(iterable, n);
  }

  if (args.length === 0) {
    return fork;
  }

  if ((0, _iterable.isIterable)(args[0])) {
    return fork(args[0], undefined);
  } else {
    return iterable => fork(iterable, args[0]);
  }
}